import { LOTTIE_VISUAL } from '../elements/lottie'
import { CONVERSATION_BOX } from '../elements/conversationBox'
import { IMAGE_DESKTOP, IMAGE_MOBILE } from '../elements/assets'
import { LINK_TITLE, BUTTON_SETTINGS } from '../elements/link'

export const TEXT_AND_IMAGE = `
...on textAndImage_Entry {
  ${ LOTTIE_VISUAL }
  ${ CONVERSATION_BOX }
  id
  typeHandle
  anchorId

  backgroundColor
  position

  heading {
    html
    plainText
  }
  description

  ${ LINK_TITLE }
  ${ BUTTON_SETTINGS }

  imageTextMatrix {
   typeHandle
    image {
      url
    }
    title
    text
    description

    iconField { url }
    ${ LINK_TITLE }
  }

  ${ IMAGE_DESKTOP }
  ${ IMAGE_MOBILE }

}
`